import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

const useSubscriberPerformerTop = (subscriberId?: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();
    const resolvedSubscriberId = useMemo(() => subscriberId || subscriber?._id, [subscriberId, subscriber?._id]);

    // Fetch
    const fetchData = async (): Promise<{ performerTop: number; isLoggedIn: boolean }> => {
        if (!resolvedSubscriberId) {
            return { performerTop: 0, isLoggedIn: false };
        }
        const query: string = `${settingsContext.routes.onlyFans.base}${resolvedSubscriberId}/performerTop`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return { performerTop: 0, isLoggedIn: false };
            });
    };

    const subscriberPerformerTop = useQuery(['subscriberPerformerTop', resolvedSubscriberId], () => fetchData(), {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60,
        retry: false,
        enabled: userContext.jwtToken && settingsContext.apiKey && resolvedSubscriberId ? true : false,
    });

    return { ...subscriberPerformerTop };
};

export default useSubscriberPerformerTop;
